import { FormatPrice } from 'components/localisation/FormatPrice';
import { useCartPromos } from 'hooks/cart/useCartPromos';

import { PromoCarousel } from './PromoCarousel';

export const CartPromos = () => {
  const {
    shouldShowOffer,
    disabled,
    remainingAmount,
    promoProducts,
    progress,
  } = useCartPromos();

  if (!shouldShowOffer) {
    return null;
  }

  const dynamicTitle = (
    <>
      {remainingAmount === 0 ? (
        'Choose your free gift'
      ) : (
        <>
          <FormatPrice
            fontWeight="medium"
            amount={remainingAmount}
            showFreeIfZero
          />{' '}
          away from a free gift
        </>
      )}
    </>
  );

  return (
    <PromoCarousel
      title={dynamicTitle}
      products={promoProducts}
      disabled={disabled}
      progress={progress}
    />
  );
};
